import { useRuntimeAutoSync } from '../features/runtime/useRuntimeAutoSync';
import { AppRoutes } from './routes';

export function App() {
  useRuntimeAutoSync();
  return <AppRoutes />;
}
